import { createPinia } from 'pinia'
import { createApp } from 'vue' 
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import VueDraggableResizable from 'vue-draggable-resizable'
import { Icon } from '@iconify/vue';
// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

import VueDragResizeRotate from "@gausszhou/vue3-drag-resize-rotate";
import "@gausszhou/vue3-drag-resize-rotate/lib/bundle.esm.css";
import "/src/theme/theme.css"
const vuetify = createVuetify({
  components,
  directives,
})
import 'vue-draggable-resizable/style.css';




import 'mdb-vue-ui-kit/css/mdb.min.css';

import App from './App.vue'


let apPH = document.getElementById("app");

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

if (apPH) {
   var componentName=apPH.dataset["componentName"];
  //  var prodId=apPH.dataset["pid"];

  // console.log(componentName);
  // if (!componentName ){

  // var componentName="ColorEditor"; 
  // var componentName="ArtEditor";
  // var componentName="FontEditor";
  // var componentName="ProductEditor"; 
  // var componentName = "TextEditor";
  // var componentName="MonogramEditor";
  // var componentName="MaterialEditor";

  // var componentName="ProductDesign";
 // var componentName="AllProducts";
  // var componentName="EmbroidMechine";
  // }


  console.log(componentName);

  let vueApp = createApp(App);

  vueApp.use(pinia);
  
  vueApp.use("vue-draggable-resizable", VueDraggableResizable)

  vueApp.use(vuetify);

  vueApp.use(VueDragResizeRotate);



  // createApp(App)
  // .component('font-awesome-icon', FontAwesomeIcon)
  // .mount('#app')

  vueApp.provide('cname', componentName);
  
  vueApp.component('icon-svg', Icon); 
  
  vueApp.mount('#app');

  window.vueApp = vueApp;
}